import { isFlightForceBundled } from 'lib/offer/isFlightForceBundled'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import React, { useCallback, useRef } from 'react'
import ModalBody from 'LuxKit/Modal/ModalBody'
import OfferCapacityWithAgesSelection from 'components/OfferPage/Filters/CapacityWithAges/OfferCapacityWithAgesSelection'
import ModalContent from 'LuxKit/Modal/ModalContent'
import { useIntl } from 'react-intl'

interface Props {
  capacities: Array<App.RoomCapacity>
  offer: App.Offer
}
function FlashMobileStickyHeaderFiltersCapacityModal(props: Props) {
  const { capacities, offer } = props
  const intl = useIntl()
  const modalElement = useModalElementContext<string>()
  const formRef = useRef<HTMLFormElement>(null)
  const onClose = useCallback(() => {
    if (formRef.current?.reportValidity()) {
      modalElement.resolve('')
    }
  }, [modalElement])

  return (<ModalBase mode="drawer">
    <form onSubmit={onClose} ref={formRef}>
      <ModalHeader
        title={intl.formatMessage({
          id: 'YuLp6DNzy4',
          defaultMessage: 'Who is going?',
          description: 'Title for capacity filter modal in the search or listing filters panel',
        })}
        onCloseButtonClick={onClose}
      />
      <ModalBody>
        <ModalContent flush>
          <OfferCapacityWithAgesSelection
            capacities={capacities}
            disableMultiRoom={isFlightForceBundled(offer)}
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: intl.formatMessage({
            id: '837i6Kprjw',
            defaultMessage: 'Confirm',
            description: 'Button text to confirm the current selection or action in a dialog or form modal',
          }),
          onClick: onClose,
        }}
      />
    </form>
  </ModalBase>)
}

export default FlashMobileStickyHeaderFiltersCapacityModal
